module.exports = __webpack_public_path__ + "static/media/Arrow-right-white.f1c7432c.svg";